import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RequestsService {

  private apiUrl = 'https://accept-capp.iti.gr/api/';

  constructor(private http: HttpClient) { }

/*************  ✨ Windsurf Command ⭐  *************/
  /**
   * Retrieves the current data for a specific date.
   * 
   * @param date - The date for which to retrieve the current data in 'yyyy-MM-dd' format.
   * @returns An observable containing the current data for the specified date.
   */

/*******  e94138ec-4272-4c34-95ce-1a992d61742d  *******/
  getCurrentData(date: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/current/?start=${date}T00:00:00.00Z&end=${date}T23:00:00.00Z`);
  }

  getDsriData(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/dsri/?mode=pilot`);
  }

  getAllDsriData(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/dsri/`);
  }

  getDRProgress(start: string, end: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/dr/?start=${start}&end=${end}`);
  }

  getStatistics(startDate: string): Observable<any> {
    const endpoint = `${this.apiUrl}/statistics/?start=${startDate}T00:00:00.00Z`;
    return this.http.get<any>(endpoint);
  }

  getDeviceMeasurements(start: string, end: string): Observable<any> {
   return this.http.get<any>(`${this.apiUrl}/devicesMeasurements/?start=${start}T00:00:00.00Z&end=${end}T23:00:00.00Z`);
  }

  getDevicesStructure(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/devicesStructure`);
  }

  getDeviceDetails(deviceName: string): Observable<any> {
    const url = `${this.apiUrl}/controllable?device=${deviceName}`;
    return this.http.get<any>(url);
  }

  getOutdoorConditions(date: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/outweather/?start=${date}T00:00:00.00Z&end=${date}T23:00:00.00Z`);
  }

  getIndoorConditions(date: string, room: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/inweather/?start=${date}T00:00:00.00Z&end=${date}T23:00:00.00Z&room=${room}`);
  }

  getStatisticsData(start: Date, end: Date): Observable<any> {
    const startDate = this.convertDate(start);
    const endDate = this.convertDate(end);
    return this.http.get<any>(`${this.apiUrl}statistics/?start=${startDate}T00:00:00.00Z&end=${endDate}T23:00:00.00Z`);
  }

  public convertDate(date: Date): string {
    const mnth = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${date.getFullYear()}-${mnth}-${day}`;
  }
  
  getRanking(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}ranking`);
  }

  getGameProfile(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}gameProfile`);
  }

  getNotificationSettings(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/notifications/settings`);
  }

  saveNotificationSettings(preferences: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/notifications/settings`, preferences);
  }

  deleteNotifications(ids: number | number[]): Observable<any> {
    const selectedIds = Array.isArray(ids) ? ids.join('&ids=') : ids;
    const url = `${this.apiUrl}/notifications/bulk_delete/?ids=${selectedIds}`;
    return this.http.delete(url);
  }  

  updateNotificationReadStatus(id: number): Observable<any> {
    const url = `${this.apiUrl}/notifications/mark_as_read/`;
    return this.http.post(url, { id });
  }

  getNotifications(start:string,end:string): Observable<number> {
    return this.http.get<any>(`${this.apiUrl}/notifications/?start=${start}&end=${end}`)
  }

  changePassword(body: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/auth/changePassword`, body);
  }

  getUserData(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/auth/user`);
  }
  

  getDemandResponseEvents(start: string, end: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}dr/?start=${start}T00:00:00.00Z&end=${end}T23:00:00.00Z`);
  }
  
  getEnergyMeasurements(start: string, end: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}energy_measurements/?start=${start}T00:00:00.00Z&end=${end}T23:00:00.00Z`);
  }
  
}

